module.exports = __webpack_public_path__ + "static/media/YM83_4.f09c7d7b.jpg";